import {
  InquiryProcessFlowMetadata,
  InquiryProcessFlowMetadataArgs,
  getInquiryProcessFlowMetadata,
} from '../../assets/ts/data/inquiry/inquiry-process-flow-metadata'
import useServerData from '../use-server-data'

function useInquiryProcessFlowMetadata(fetchArgs) {
  const {
    data: inquiryProcessFlowMetadata,
    error: inquiryProcessFlowMetadataError,
    fetchData: fetchinquiryProcessFlowMetadata,
    isLoading: inquiryProcessFlowMetadataIsLoading,
  } = useServerData<InquiryProcessFlowMetadata, InquiryProcessFlowMetadataArgs>(
    getInquiryProcessFlowMetadata,
    fetchArgs
  )

  return {
    fetchinquiryProcessFlowMetadata,
    inquiryProcessFlowMetadata,
    inquiryProcessFlowMetadataError,
    inquiryProcessFlowMetadataIsLoading,
  }
}

export default useInquiryProcessFlowMetadata
